const inputErrorLabelNew = {
  label: 'El campo de mensajes no puede estar vacío'
};

export default inputErrorLabelNew;
